<template>
  <b-container fluid v-if="submission.submissionId">

    <b-row class="mb-1"> 
      <b-col cols="12" lg="6" class="mb-1">
        <h2>{{submission.lastName}}, {{submission.firstName}} - {{submission.dateOfBirth}} - {{submission.sex}} </h2>
        <span v-if="submission.streetAddress">{{submission.streetAddress}}</span>
        <span><br/>{{submission.city}} {{submission.state}} {{submission.zip}} {{submission.county}}</span>
        <br/><small>{{livingSetting}}</small>
      </b-col>
      <b-col cols="12" lg="6" class="mb-1"> <br/>
        <strong>MEDSS Event Id: </strong>{{submission.medssEventId}} <br/>
      </b-col>
    </b-row>

    <b-row v-if="submission.covidSymptoms === 'X'">
      <b-col>
        <b-alert show variant="warning">
          <b-row>
            <b-col cols="1">
              <b-icon icon="exclamation-diamond-fill" style="width: 60px; height: 60px;"/>
            </b-col>
            <b-col cols="11">
              Self Reported COVID Symptoms starting on {{submission.covidSymptomsStart}}.<br/>
              <span v-if="submission.prexistingConditions">
                Underlying/Pre-existing Conditions: {{submission.prexistingConditions}}
              </span>
            </b-col>
          </b-row>
          </b-alert>
      </b-col>
    </b-row>

    <div class="card mb-3">
      <strong class="card-header">Contact Details</strong>
      <div class="card-body">
        <b-row>
          <b-col cols="12" lg="4" class="fieldHeader">Email Address</b-col>
          <b-col cols="12" lg="8">{{submission.emailAddress ? submission.emailAddress : 'Not Provided.'}}</b-col>
          <b-col cols="12" lg="4" class="fieldHeader">Primary Phone Number</b-col>
          <b-col cols="12" lg="8">{{submission.phoneNbr ? submission.phoneNbr : 'Not Provided.'}}</b-col>
          <b-col cols="12" lg="4" class="fieldHeader">Secondary Phone Number</b-col>
          <b-col cols="12" lg="8">{{submission.otherPhoneNbr ? submission.otherPhoneNbr : 'Not Provided.'}}</b-col>    
                
        </b-row>

      </div>
    </div>

    <div class="card mb-3" v-if="false">
      <strong class="card-header">Contact Tracing Overview</strong>
      <div class="card-body">
        <b-row>
          <b-col cols="12" lg="4" class="fieldHeader">Currently Employed?</b-col>
          <b-col cols="12" lg="8">{{submission.currentlyEmployed ? submission.currentlyEmployed : 'Not Provided.'}}  {{submission.currentEmployer ? submission.currentEmployer : ''}}</b-col>
          <b-col cols="12" lg="4" class="fieldHeader">Attended a School/Daycare?</b-col>
          <b-col cols="12" lg="8">{{submission.currentlyEmployed ? submission.currentlySchooled : 'Not Provided.'}}  {{submission.currentSchool ? submission.currentSchool : ''}}</b-col>
          <b-col cols="12" lg="4" class="fieldHeader">Attended/Worked at College?</b-col>
          <b-col cols="12" lg="8">{{submission.currentlyEmployed ? submission.currentlyCollege : 'Not Provided.'}}  {{submission.currentCollege ? submission.currentCollege : ''}}</b-col>
          <b-col cols="12" lg="4" class="fieldHeader">Within Social Distance?</b-col>
          <b-col cols="12" lg="8">{{submission.currentlyEmployed ? submission.nonhouseholdContact : 'Not Provided.'}}</b-col>
        </b-row>
      </div>
    </div>

    <div class="card mb-3" v-if="false">
      <strong class="card-header">Health History</strong>
      <div class="card-body">
        <b-row>
          <b-col cols="12" lg="4" class="fieldHeader">Underlying Conditions?</b-col>
          <b-col cols="12" lg="8">{{submission.underlyingConditions ? submission.underlyingConditions : 'Not Provided.'}}  {{submission.prexistingConditions ? submission.prexistingConditions : 'No pre-existing conditions reported.'}}</b-col>
          <b-col cols="12" lg="4" class="fieldHeader">Currently pregnant?</b-col>
          <b-col cols="12" lg="8">{{submission.currentlyEmployed ? submission.pregnant : 'Not Provided.'}} </b-col>
        </b-row>
      </div>
    </div>

    <div class="card mb-3" v-if="false">
      <strong class="card-header">Exposures</strong>
      <div class="card-body">
        <b-row>
          <b-col cols="12" lg="4" class="fieldHeader">Travel outside of MN?</b-col>
          <b-col cols="12" lg="8">{{submission.anyTravels ? submission.anyTravels : 'Not Provided.'}}</b-col>
          <b-col cols="12" lg="4" class="fieldHeader">Travel outside of USA?</b-col>
          <b-col cols="12" lg="8">{{submission.travelOutsideUsa ? submission.travelOutsideUsa : 'Not Provided.'}}</b-col>
          <b-col cols="12" lg="4" class="fieldHeader">Travel via Cruise?</b-col>
          <b-col cols="12" lg="8">{{submission.travelCruise ? submission.travelCruise : 'Not Provided.'}}</b-col>
          <b-col cols="12" lg="4" class="fieldHeader">Travel via Air?</b-col>
          <b-col cols="12" lg="8">{{submission.travelAir ? submission.travelAir : 'Not Provided.'}}</b-col>
          <b-col cols="12" lg="4" class="fieldHeader">Travel Destination?</b-col>
          <b-col cols="12" lg="8">{{submission.travelDestination ? submission.travelDestination : 'Not Provided.'}}</b-col>
          <b-col cols="12" lg="4" class="fieldHeader">Travel Start Date?</b-col>
          <b-col cols="12" lg="8">{{submission.travelStart ? submission.travelStart : 'Not Provided.'}}</b-col>
          <b-col cols="12" lg="4" class="fieldHeader">Travel End Date?</b-col>
          <b-col cols="12" lg="8">{{submission.travelEnd ? submission.travelEnd : 'Not Provided.'}}</b-col>
        </b-row>

        <b-row class="mt-2">
          <b-col cols="12" lg="4" class="fieldHeader">Did you work at, live at, visit or otherwise have any contact with a nursing home, long-term care facility, group home, or other similar type facility?</b-col>
          <b-col cols="12" lg="8">{{submission.healthCareExposure ? submission.healthCareExposure : 'Not Provided.'}}</b-col>          
        </b-row>
      </div>
    </div>

    <div class="card mb-3" v-if="false">
      <strong class="card-header">Contacts</strong>
      <div class="card-body">

        <div class="card mb-2" v-for="contact in submission.contacts" v-bind:key="contact.id">
          <strong class="card-header">{{contact.firstName}} {{contact.lastName}}</strong>
          <div class="card-body">
            <b-row>
              <b-col cols="12" lg="4" class="fieldHeader">Age</b-col>
              <b-col cols="12" lg="8">{{contact.age ? contact.age : 'Not Provided.'}}</b-col>
              <b-col cols="12" lg="4" class="fieldHeader">Live Together?</b-col>
              <b-col cols="12" lg="8">{{contact.liveTogether ? contact.liveTogether : 'Not Provided.'}}</b-col>
              <b-col cols="12" lg="4" class="fieldHeader">Phone Number</b-col>
              <b-col cols="12" lg="8">{{contact.phone ? contact.phone : 'Not Provided.'}}</b-col>
              <b-col cols="12" lg="4" class="fieldHeader">Email Address</b-col>
              <b-col cols="12" lg="8">{{contact.email ? contact.email : 'Not Provided.'}}</b-col>
              <b-col cols="12" lg="4" class="fieldHeader">Works at health care facility?</b-col>
              <b-col cols="12" lg="8">{{contact.healthCareWorker ? contact.healthCareWorker : 'Not Provided.'}}</b-col>
              <b-col cols="12" lg="4" class="fieldHeader">Works at nursing home, LTC, rehab facility?</b-col>
              <b-col cols="12" lg="8">{{contact.longTermCareWorker ? contact.longTermCareWorker : 'Not Provided.'}}</b-col>
              <b-col cols="12" lg="4" class="fieldHeader">Works at group home?</b-col>
              <b-col cols="12" lg="8">{{contact.groupHomeWorker ? contact.groupHomeWorker : 'Not Provided.'}}</b-col>
              <b-col cols="12" lg="4" class="fieldHeader">Works at correctional facility?</b-col>
              <b-col cols="12" lg="8">{{contact.correctionalWorker ? contact.correctionalWorker : 'Not Provided.'}}</b-col>
              <b-col cols="12" lg="4" class="fieldHeader">Works at homelessness shelter?</b-col>
              <b-col cols="12" lg="8">{{contact.homelessShelterWorker ? contact.homelessShelterWorker : 'Not Provided.'}}</b-col>
              <b-col cols="12" lg="4" class="fieldHeader">Employer Information</b-col>
              <b-col cols="12" lg="8">{{contact.employer ? contact.employer : 'Not Provided.'}}</b-col>
            </b-row>
          </div>
        </div>

    </div>
  </div>

   <div class="card mb-3" v-if="false">
      <strong class="card-header">Workplace</strong>
      <div class="card-body">
        <b-row>
          <b-col cols="12" lg="4" class="fieldHeader">Workplace Setting of Interest?</b-col>
          <b-col cols="12" lg="8">{{submission.workplaceSetting ? submission.workplaceSetting : 'Not Provided.'}}</b-col>
          <b-col cols="12" lg="4" class="fieldHeader">Employer Name</b-col>
          <b-col cols="12" lg="8">{{submission.employerName ? submission.employerName : 'Not Provided.'}}</b-col>
          <b-col cols="12" lg="4" class="fieldHeader">Employer Location/Address</b-col>
          <b-col cols="12" lg="8">{{submission.employerAddress ? submission.employerAddress : 'Not Provided.'}}</b-col>
          <b-col cols="12" lg="4" class="fieldHeader">Occupation</b-col>
          <b-col cols="12" lg="8">{{submission.occupation ? submission.occupation : 'Not Provided.'}}</b-col>
          <b-col cols="12" lg="4" class="fieldHeader">Permission to Contact?</b-col>
          <b-col cols="12" lg="8">{{submission.employerShare ? submission.employerShare : 'Not Provided.'}}</b-col>
          <b-col cols="12" lg="4" class="fieldHeader">Contact Person</b-col>
          <b-col cols="12" lg="8">{{submission.employerContactName ? submission.employerContactName : 'Not Provided.'}}</b-col>
          <b-col cols="12" lg="4" class="fieldHeader">Contact Details</b-col>
          <b-col cols="12" lg="8">{{submission.employerContactInfo ? submission.employerContactInfo : 'Not Provided.'}}</b-col>
        </b-row>
      </div>
    </div>

    <div class="card mb-3">
      <strong class="card-header">Action</strong>
      <div class="card-body">
        <b-row>
          <b-col cols="3">
              <label for="input"><strong>MEDSS Event Id:</strong></label><br/>
               <b-form-input id="input" :state="null" v-model="editedMedssId"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <label for="input"><strong>Review Comments:</strong></label><br/>
               <b-form-input id="input" :state="null" v-model="submission.reviewComments"></b-form-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
               <b-button variant="primary" class="mt-4" @click="updateSubmission">Resolve, Import into MEDSS</b-button>
               <div>
                <b-button class=" mt-4" size="sm" @click="trashSubmission">Ignore, Do not import into MEDSS</b-button>
                <b-button class="ml-2 mt-4" size="sm" @click="saveSubmission">Save Comments, No Status Change</b-button>
               </div>
          </b-col>
        </b-row>
      </div>
    </div>

  </b-container>

  <b-container v-else>
    <b-alert show variant="danger">Could not locate a Submission for code {{submission.id}}. <br/> Please try again.</b-alert>
  </b-container>
</template>

<script>

import { commonOptions } from '@/mixins/commonOptions.js'
 import axios from 'axios'
import axiosRetry from 'axios-retry'
export default {

  mixins: [
       commonOptions
  ],

  data: () => ({
    editedMedssId: ''
  }),

  props: {
    submission: Object
  },

  created() {
    this.editedMedssId = this.submission.medssEventId
  },

  methods: {
    updateSubmission() {
      let payload = {
        submissionId: this.submission.submissionId,
        eventId: this.editedMedssId,
        comments: this.submission.reviewComments
      }

       axios.post(`${process.env.VUE_APP_API_BASE_URL}/search/submission/release`, payload)
            .then(response => { 
               this.showRootToast("Submission Has Been Updated", "Success", "success")
               this.$bvModal.hide('modal-crud');
               this.$emit('refresh-list', true)
            });
    },

    trashSubmission() {
      let payload = {
        submissionId: this.submission.submissionId,
        eventId: this.editedMedssId,
        comments: this.submission.reviewComments
      }

       axios.post(`${process.env.VUE_APP_API_BASE_URL}/search/submission/trash`, payload)
            .then(response => { 
               this.showRootToast("Submission Has Been Updated", "Success", "success")
               this.$bvModal.hide('modal-crud');
               this.$emit('refresh-list', true)
            });
    },

    saveSubmission() {
      let payload = {
        submissionId: this.submission.submissionId,
        eventId: this.editedMedssId,
        comments: this.submission.reviewComments
      }

       axios.post(`${process.env.VUE_APP_API_BASE_URL}/search/submission/comments`, payload)
            .then(response => { 
               this.showRootToast("Submission Has Been Updated", "Success", "success")
               this.$bvModal.hide('modal-crud');
               this.$emit('refresh-list', true)
            });
    },

    showRootToast(title, message, type) {
      this.$root.$bvToast.toast(message, {
            title: title,
            toaster: 'b-toaster-top-center',
            solid: true,
            variant: type,
            appendToast: true
          })
    },
  },

  computed: {
    livingSetting: function() {
      if (this.submission.livingSetting) {
        let obj = this.livingOptions.find(o => o.value === this.submission.livingSetting);
        if ( obj ) {
          return obj.text
        }
      }
      return 'Living setting not answered.'
    }
  }
}
</script>

<style>
  .fieldHeader { 
    background-color: silver;
  }
</style>
